// Single source of truth for the consultation booking link. Every
// "Book a Free Consultation" button on the site reads from here.
export const CONSULTATION_URL = 'https://cal.com/team/brainfy-ai/brainfy-ai-consultation';
export const CONSULTATION_MINUTES = 30;
